(function () {
    'use strict';

    angular
        .module('edufindme')
        .controller('AccountDeleteRequestController', AccountDeleteRequestController);

        AccountDeleteRequestController.$inject = ['DeleteClientsService', '$scope', 'EdufindmeReportService', 'toastr'];


    function AccountDeleteRequestController(DeleteClientsService, $scope, EdufindmeReportService, toastr) {
        
        var vm = this;
        vm.search               = '';
        vm.csv                  = null;
        vm.getByFilter          = getByFilter;
        vm.accountDeleteRequest = accountDeleteRequest;
        vm.requestCSVDelete     = requestCSVDelete;
        vm.uploadHandler        = uploadHandler;
        vm.users                = []
        vm.flag                 = false;
        vm.buttonDisabled       = false;

        function getByFilter() {
            vm.flag = false;
            vm.users = [];
            DeleteClientsService.findByEmail(vm.search).then(response => {
                vm.buttonDisabled = false;
                vm.flag = true;
                vm.users = response.data;
            });
            
        }

        function requestCSVDelete(){
            let data = {
                file: vm.csv
            }

            DeleteClientsService.deleteByCsv(data).then(response => {
                vm.csv = null;
                toastr.success(`Account Request Successfull created!`);
            });
        }

        function uploadHandler(e) {

            if (e.currentTarget.files.length) {
                var file = e.currentTarget.files[0];
                var reader = new FileReader();
                reader.onload = function (e) {
                    $scope.$apply(function() {
                        vm.csv  = e.target.result;
                        console.log(e.target.result)
                    });
                };
                reader.readAsDataURL(file);
            }
        }    

        function accountDeleteRequest(id) {
            vm.buttonDisabled = true;
            EdufindmeReportService.accountDeleteRequest(id).then(response => {
                toastr.success(`Account Request Successfull created!`);
            });
        }

        function activate () {}

        activate();
    }

})();